import React, { useReducer, useRef, useState } from "react";
import classes from './QuestionnaireEditor.module.css';
import QuestionsOptionsImg from '../assests/quetion-options.svg';
import QuestionsTextImg from '../assests/quetion-text.svg';
import Question from "./Questions/Question";
import { useEffect } from "react";
import Drag from "./Drag";
import { uuidv4 } from "../Editor/utils";
import { useSelector } from "react-redux";
import UploadPopup from "./UploadPopup/UploadPopup";

const QuestionnaireReducer = (quetions, action,) => {
    let newState = [...quetions];
    const swapContents = (sourceIndex, destinationIndex) => {
        // Remove dragged item
        const [reorderedItem] = newState.splice(sourceIndex, 1);
        // Add dropped item
        newState.splice(destinationIndex, 0, reorderedItem);
    }
    switch (action.type) {
        case 'INIT':
            newState = action.quetions
            return newState;
        case 'ADD':
            newState.push({ type: action.quetionType, name: 'שאלה', points: 1, id: uuidv4(), data: { ...quetionsTypesEnum[action.quetionType].initValue } })
            return newState;
        case 'EDIT':
            const editElem = newState[action.index]
            newState[action.index] = { ...editElem, ...action.newData };
            return newState;
        case 'DELETE':
            newState.splice(action.index, 1);
            return newState;
        case 'DUPLICATE':
            const copy = newState[action.index];
            newState.splice(action.index + 1, 0, { ...copy, id: uuidv4() });
            return newState;
        case 'ORDER_UP':
            if (action.index > 0)
                swapContents(action.index, action.index - 1);
            return newState;
        case 'OREDR_DOWN':
            if (action.index !== newState.length - 1)
                swapContents(action.index, action.index + 1);
            return newState;
        default:
            throw new Error('Should not get there')
    }
};

const quetionsTypesEnum = {
    'options': {
        name: "option",
        img: QuestionsOptionsImg,
        initValue: { multiple: false, options: [{ correct: false, content: '', id: uuidv4() }, { correct: false, content: '', id: uuidv4() }] },
        config: [{ name: 'multiple', text: "allowFewOptions", default: false }, { name: 'survey', text: "surveyQuestion", default: false }]
    },
    'text': {
        name: "text",
        img: QuestionsTextImg,
        initValue: { longAnswer: true, correctAnswers: [] },
        config: [{ name: 'longAnswer', text: "openAnswer", default: false }]
    }
}

const QuestionnaireEditor = ({ data, setContentData, index }) => {
    const [quetions, dispatch] = useReducer(QuestionnaireReducer, [])
    const [showCreatePopup, setShowCreatePopup] = useState();
    const [showImageUploadPopup, setShowImageUploadPopup] = useState();
    const [showVideoUploadPopup, setShowVideoUploadPopup] = useState();
    const first = useRef(true);

    const { texts } = useSelector(state => state.translate);

    useEffect(() => {
        if (!first.current) {
            setContentData({ ...data, quetions });
        }
        else {
            first.current = false;
        }

    }, [quetions])

    useEffect(() => {
        if (!data) {
            dispatch({ type: 'INIT', quetions: [] })
            setContentData({ ...data, title: texts.questionnaireTitle, style: { width: '70%' } });
        }
        else {
            first.current = true;
            dispatch({ type: 'INIT', quetions: data.quetions.map(x => ({ ...x, id: x.id ? x.id : uuidv4() })) });
        }
    }, [index])

    const uplaodBG = (values) => {
        setContentData({ ...data, bgImage: values });
        setShowImageUploadPopup(false)
    }

    const uplaodVideo = (values) => {
        setContentData({ ...data, video: values });
        setShowVideoUploadPopup(false)
    }

    const changeStyle = (style) => {
        setContentData({ ...data, style: style });
    }

    const changeVideoStyle = (style) => {
        style.url = data.video?.url
        style.isFile = data.video?.isFile
        setContentData({ ...data, video: style });
    }

    const handleDeleteVideo = (event) => {
        if (event.keyCode === 46 || event.keyCode == 8) {
            setContentData({ ...data, video: null });
        }
    }

    const handleVideoClick = (event) => {
        if (event.target === event.currentTarget) {
            event.preventDefault();
        }
    }

    return <div className={classes.QuestionnaireEditor} onClick={() => setShowCreatePopup(false)}>
        <div className={classes.EditHeader}>
            <button className={classes.Btn} onClick={() => setShowImageUploadPopup(true)} >{texts.addBGImage}</button>
            <button className={classes.Btn} onClick={() => setShowVideoUploadPopup(true)} >{texts.addVideo}</button>
        </div>
        {(showImageUploadPopup || showVideoUploadPopup) &&
            <UploadPopup
                popupType={showImageUploadPopup ? 'image' : 'video'}
                initValues={data && (showImageUploadPopup ? data.bgImage : data.video)}
                addCallback={showImageUploadPopup ? uplaodBG : uplaodVideo}
                close={() => { setShowImageUploadPopup(false); setShowVideoUploadPopup(false) }} />}
        {/* <div className={classes.Name}> <input className={classes.InputName} value={data && data.title} onChange={(e) => setContentData({...data,title:e.target.value})}></input></div> */}
        <div className={classes.QuestionnaireBG} style={data && data.bgImage ? { backgroundImage: `url(${data.bgImage.url})`, ...data.bgImage } : {}}>
            {data.video &&
                <Drag change={changeVideoStyle} style={data.video} minSize={100} disableRotate={true} onRemoveRect={()=>setContentData({ ...data, video: null })}>
                    <div onClick={handleVideoClick} onKeyDown={handleDeleteVideo}>
                        {data.video.isFile ?
                            <video
                                className={classes.Video}
                                src={data.video.url}
                                style={data.video}
                                onClick={handleVideoClick}
                                controls
                            /> :
                            <iframe
                                className={classes.Video}
                                src={data.video.url}
                                style={data.video}
                                onClick={handleVideoClick}
                                allowFullScreen
                            ></iframe>}
                    </div>
                </Drag>}
            <Drag change={changeStyle} style={data.style} minSize={100} disableHeightChange={true} disableRotate={true} disableCornersChange={true} >
                <div className={classes.Questionnaire} >
                    <div className={classes.QuestionList}>
                        {quetions && quetions.map((q, index) => (
                        <Question
                            key={index}
                            {...q}
                            index={index + 1}
                            config={quetionsTypesEnum[q.type].config}
                            setQuestionFirstLevelFields={(data) => dispatch({ type: 'EDIT', index: index, newData: data })}
                            onDelete={() => dispatch({ type: "DELETE", index: index })}
                            onDuplicate={() => dispatch({ type: "DUPLICATE", index: index })}
                            onOrderUp={() => dispatch({ type: "ORDER_UP", index: index })}
                            onOrderDown={() => dispatch({ type: "OREDR_DOWN", index: index })}
                        ></Question>))}


                    </div>
                    <div className={classes.New} onClick={(e) => e.stopPropagation()}>
                        <div className={classes.NewIcon} onClick={() => setShowCreatePopup(preShow => !preShow)}>+</div>
                        {!showCreatePopup && <button className={classes.NewBtn} onClick={() => setShowCreatePopup(true)}>{texts.addQuestion}</button>}
                        {showCreatePopup && <div className={classes.CreatePopup}>
                            {Object.keys(quetionsTypesEnum).map(key => <div className={classes.Type} key={key} onClick={() => dispatch({ type: 'ADD', quetionType: key })}>
                                <div className={classes.TypeImg} style={{ backgroundImage: `url(${quetionsTypesEnum[key].img})` }}></div>
                                <div className={classes.TypeText}>{texts[quetionsTypesEnum[key].name]}</div>
                            </div>)}
                        </div>}
                    </div>
                </div>
            </Drag>
        </div>
    </div>
}

export default QuestionnaireEditor;